export const HIDE_TAGS_WITH_PREFIX = ['ID:'] as const
export const HIDE_IF_EMPTY_COMPONENT_ID_TAG_PREFIX = 'hide-if-empty-id:'
export const HIDE_IF_EMPTY_COMPONENT_TRACKING_ID_TAG_PREFIX = 'hide-if-empty-tracking-id:'
